export default function AboutData() {
    return {
        title: "About Supplemental Insurance",
        content:
            "You can't predict when an accident or unexpected health issue might happen. Aflac provides individuals and families affordable insurance that helps with expenses that may not be covered by major medical insurance.",
    }
}